import { AnimatedContainer, Flex, Loader, MarkdownPreview, Typography } from '@percent/lemonade';

import { ReactComponent as SuccessResultBadge } from '@percent/grants-nomination-form/assets/images/success-result-badge.svg';

import { Layout } from '@percent/grants-nomination-form/ui';
import { useNominationForm } from '@percent/grants-nomination-form/hooks';
import { Navigate, useParams } from 'react-router-dom';
import styles from './Confirmation.module.scss';

export const Confirmation = () => {
  const { programId } = useParams();
  const { nominationFormData, isLoading, nominationFormState } = useNominationForm();

  if (isLoading || !nominationFormData) {
    return <Loader />;
  }

  if (nominationFormState !== 'submitted') {
    return <Navigate to={`/${programId}`} />;
  }

  return (
    <Layout logo={nominationFormData.logo} programName={nominationFormData.programName}>
      <Flex className={styles.confirmationWrapper}>
        <AnimatedContainer>
          <SuccessResultBadge data-testid="success-result-badge" />
        </AnimatedContainer>
        <Typography variant="h2">{nominationFormData.postSubmitTitle}</Typography>
        <MarkdownPreview content={nominationFormData.postSubmitDescription} />
      </Flex>
    </Layout>
  );
};
